import { atom, useAtomValue, useSetAtom } from 'jotai';

const onlineState = atom(true);

export const useOnline = () => useAtomValue(onlineState);
export const useSetOnline = () => useSetAtom(onlineState);
